// Return a badge colour based on incoming number
export const stockSeverity = (data) => {
    if (data < 0) return 'danger';
    else if (data > 0 && data < 10) return 'warn';
    else return 'success';
}

// Project status: use global standard (see projectStatusColours.js and frontend-docs/docs/standards/project-status-colours.md)
import { getProjectStatusSeverity } from '@/utils/projectStatusColours';
export const projectSeverity = (data) => {
    const name = data?.global_status?.name ?? data?.name ?? data;
    return getProjectStatusSeverity(name);
}

//Return an Invoice colour based on the input
export const invoiceSeverity = (data) => {
    console.log(data)
    if (data === 'draft') return 'warn';
    else if (data === 'overdue') return 'danger';
    else if (data === 'sent') return 'info';
    else return 'success';
}

// Return a badge severity for vehicle status
export const vehicleSeverity = (data) => {
    if (!data) return 'secondary';
    const s = String(data).toLowerCase();
    if (s === 'offroad' || s === 'inactive') return 'danger';
    if (s === 'maintenance' || s === 'busy') return 'warn';
    return 'success';
}

//Return a difficulty based on easy, medium, or hard
export const difficultySeverity = (data) => {
    console.log(data)
    if (data === 'easy') return 'success';
    else if (data === 'medium') return 'warning';
    else return 'danger';
}

//Return a Transport colour
export const transportSeverity = (data) => {
    if (data === 'waiting') return 'warn';
    else if (data === 'in progress') return 'danger';
    else return 'success';
}

//Return a Crewing colour
export const crewingSeverity = (data) => {
    if (data === 'not booked') return 'danger';
    else if (data === 'waiting') return 'warn';
    else return 'success';
}

//Return a Case Type
export const caseType = (data) => {
    if (data === 'temporary') return 'info';
    else if (data === 'permanent') return 'warn';
    else return 'info';
}

// Return a badge colour based on incoming number
export const shortageSeverity = (data) => {
    if (data > 10) return 'danger';
    else if (data > 0 && data < 10) return 'warn';
    else return 'success';
}

// Return a badge colour based on incoming number
export const accessoryType = (data) => {
    if (data === 'optional') return 'warn';
    else return 'danger';
}

// Return a badge colour based on incoming number
export const stockType = (data) => {
    if (data === 'Available') return 'success';
    else if (data === 'In Use') return 'danger';
    else if (data === 'Maintenance') return 'warning';
    else if (data === 'Missing') return 'danger';
    else if (data === 'workshop') return 'warn';
    else if (data === 'unavailable') return 'danger';
    else return 'info';
}

// Return a badge colour based on quote status
export const quoteSeverity = (data) => {
    if (data === 'draft') return 'info';
    else if (data === 'sent') return 'warn';
    else if (data === 'rejected') return 'danger';
    else if (data === 'approved') return 'success';
    else return 'info';
}



